import { dispatch, state } from '__common/store';
import { GET_WHATS_NEW, OPEN_WHATS_NEW } from './WhatsNewActions';

export const loadWhatsNew = (autoOpen: boolean = false) => {
  dispatch(GET_WHATS_NEW(autoOpen));
};

export const openWhatsNew = () => {
  const { whatsNew: { releases } } = state();

  if (!releases || releases.length === 0) {
    dispatch(GET_WHATS_NEW(false));
  }

  dispatch(OPEN_WHATS_NEW());
};
